import React from 'react';
import './HeroSection.css';
import bgImage from '../../assets/heroturan.png'; 

function HeroSection() {
  return (
    <section 
      className="hero-container" 
      id="anasayfa"
      style={{ backgroundImage: `url(${bgImage})` }} 
    >
      <div className="hero-overlay"></div>
      
      <div className="hero-content">
        {/* Vurucu kelimeyi span içine aldık */}
        <h1>Matematikte <span className="highlight-gold">Başarıya</span> Giden Yolu Birlikte Çizelim</h1>
        <p>
          Kişiye özel çalışma programları, yeni nesil soru çözümleri ve birebir takiple hedeflerinize ulaşın. BİLSEM, YKS, LGS ve okul sınavlarında <span className="highlight-gold">fark yaratın!</span>
        </p>
        <div className="hero-buttons">
          <a href="#iletisim" className="hero-btn-primary">Hemen İletişime Geç</a>
          <a href="#hakkinda" className="hero-btn-secondary">Turan Hoca Kimdir?</a>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;